import React from "react";
import { useTranslation } from "react-i18next";
import "./LoadingComponent.css";

/** Folding-cube loader (SpinKit), themed with the brand color. */
const LoadingComponent: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="gs-loader" role="status" aria-label={t('common.loading')}>
            <div className="sk-folding-cube">
                <div className="sk-cube1 sk-cube" />
                <div className="sk-cube2 sk-cube" />
                <div className="sk-cube4 sk-cube" />
                <div className="sk-cube3 sk-cube" />
            </div>
        </div>
    );
};

export default LoadingComponent;
